import React, { useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";

interface ColumnChartProps {
  leadCount: any[];
  title?: string;
  status?: string;
}

const ColumnChart: React.FC<ColumnChartProps> = ({
  leadCount = [],
  title = "Lead Type Distribution",
}) => {
  // Convert your reduce logic into recharts data format
  const data = useMemo(() => {
    const hotTotal = leadCount.reduce(
      (sum: number, item: any) => sum + (item.highIntent || 0),
      0
    );

    const warmTotal = leadCount.reduce(
      (sum: number, item: any) => sum + (item.mediumIntent || 0),
      0
    );

    const interestedTotal = leadCount.reduce(
      (sum: number, item: any) => sum + (item.lowIntent || 0),
      0
    );

    return [
      { type: "High Intent", count: hotTotal, fill: "#065f46" },
      { type: "Medium Intent", count: warmTotal, fill: "#3730a3" },
      { type: "Low Intent", count: interestedTotal, fill: "#374151" },
    ];
  }, [leadCount]);

  return (
    <div className="chart-container">
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height={330}>
          <BarChart data={data} barCategoryGap={40}>
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              opacity={0.25}
            />

            <XAxis
              dataKey="type"
              tickLine={false}
              axisLine={false}
              fontSize={12}
            />

            <YAxis tickLine={false} axisLine={false} fontSize={12} />

            <Tooltip
              cursor={{ opacity: 0.08 }}
              contentStyle={{
                borderRadius: 12,
                border: "1px solid rgba(0,0,0,0.08)",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              }}
            />

            {/* Single bar with dynamic colors */}
            <Bar dataKey="count" radius={[10, 10, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.fill} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ColumnChart;
